// eslint-disable-next-line import/prefer-default-export
export const displayMode = {
  Irs: 1,
  Stacked: 2,
  Mobile: 3
};
